import React, { useEffect } from 'react';
import WorkSundayReportDataTable from './WorkSundayReportDataTable';

const WorkedSundayReportIndex = ({ rrhh }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <WorkSundayReportDataTable rrhh={rrhh} />;
};

export default WorkedSundayReportIndex;
